'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Styles = require("../styles");
var Tile = /** @class */ (function (_super) {
    __extends(Tile, _super);
    function Tile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Searches Styles.tile.edgeLengthAdjustments for a relevant entry, given the
     * provided edge length.
     */
    Tile.prototype.getStyleAdjustments = function (edgeLength) {
        var styles = {};
        for (var i = 0; i < Styles.tile.edgeLengthAdjustments.length; i++) {
            if (edgeLength <= Styles.tile.edgeLengthAdjustments[i].edgeLength) {
                styles = Styles.tile.edgeLengthAdjustments[i].styles;
                break;
            }
        }
        return (styles);
    };
    Tile.prototype.render = function () {
        var _this = this;
        var style = __assign({}, Styles.tile.base);
        var content = '';
        var edgeLength = this.props.maxEdgeLength;
        if (this.props.revealed) {
            style = __assign({}, style, Styles.tile.revealed);
            if (this.props.hasFlag) {
                if (this.props.hasMine) {
                    style = __assign({}, style, Styles.tile.flag);
                }
                else {
                    style = __assign({}, style, Styles.tile.incorrectFlag);
                }
            }
            else if (this.props.hasMine) {
                style = __assign({}, style, Styles.tile.mine);
            }
            else if (this.props.numAdjacentMines > 0) {
                content = "" + this.props.numAdjacentMines;
                style = __assign({}, style, Styles.tile.adjacentMines[this.props.numAdjacentMines], this.getStyleAdjustments(edgeLength));
            }
        }
        else if (this.props.hasFlag) {
            style = __assign({}, style, Styles.tile.flag);
        }
        if (this.props.lastInRow) {
            style = __assign({}, style, Styles.tile.lastInRow);
        }
        style = __assign({}, style, { width: edgeLength + "px", height: edgeLength + "px", lineHeight: edgeLength + "px" });
        return (React.createElement("div", { id: "tile-" + this.props.index, style: style, onMouseUp: function (e) { return _this.props.onMouseUp(_this.props.index, e.button, e.buttons); }, onContextMenu: function (e) { return e.preventDefault(); } }, content));
    };
    return Tile;
}(React.Component));
exports.Tile = Tile;
//# sourceMappingURL=Tile.js.map


//////////////////
// WEBPACK FOOTER
// ./src/js/components/Tile.js
// module id = 37
// module chunks = 0